<template>
  <header class="header">
    <div class="header__inner">
      <router-link class="header__logo" :to="{ name: 'Home' }" aria-label="T2">
        <LogoSVG />
      </router-link>
      <span class="header__divider" aria-hidden="true" />
      <p class="header__tagline">Работодатель<br />нового поколения</p>
    </div>
  </header>
</template>

<script setup>
import LogoSVG from "@/components/LogoSVG.vue";
</script>

<style lang="scss" scoped>
.header {
  background: var(--colorBlack);
  padding: 12px;
  @include md {
    // В макете main line стоит на x=64 при 1440 — отступ как у остальных секций.
    padding: 16px 64px;
  }

  &__inner {
    max-width: var(--widthContainer);
    margin: 0 auto;
    display: flex;
    align-items: center;
    gap: 16px;
    @include md {
      gap: 24px;
    }
  }

  &__logo {
    flex-shrink: 0;
    display: block;
    width: 40px;
    height: 40px;
    @include md {
      width: 56px;
      height: 56px;
    }
    svg {
      display: block;
      width: 100%;
      height: 100%;
    }
  }

  &__divider {
    flex-shrink: 0;
    width: 1px;
    height: 25px;
    background: var(--colorWhite);
    // В макете разделитель и слоган стоят на 3px ниже центра строки —
    // логотип при этом выровнен по центру ровно.
    transform: translateY(3px);
    @include md {
      height: 36px;
    }
  }

  &__tagline {
    color: var(--colorWhite);
    font-size: 12px;
    line-height: 14px;
    // См. комментарий у &__divider.
    transform: translateY(3px);
    @include md {
      font-size: 18px;
      // В макете две строки занимают 44px — это line-height 22px.
      line-height: 22px;
    }
  }
}
</style>
